var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeadsetIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 58 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29,5.47A20.71,20.71,0,0,0,8.32,26.15V37.37a4.13,4.13,0,0,0,4.13,4.13h1.62a4.14,4.14,0,0,0,8-1.38V28.91a4.14,4.14,0,0,0-8-1.38H12.45a4,4,0,0,0-1.38.24V26.15a17.93,17.93,0,0,1,35.86,0v1.62a4,4,0,0,0-1.38-.24H43.93a4.14,4.14,0,0,0-8,1.38V40.12A4.15,4.15,0,0,0,40,44.26a4,4,0,0,0,1.2-.18,4.13,4.13,0,0,1-4,2.94H32.9a4.13,4.13,0,1,0,0,2.76h4.37a6.91,6.91,0,0,0,6.9-6.9V41.5h1.38a4.13,4.13,0,0,0,4.13-4.13V26.15A20.71,20.71,0,0,0,29,5.47ZM16.59,28.91a1.38,1.38,0,0,1,2.76,0V40.12a1.38,1.38,0,0,1-2.76,0Zm-4.14,1.38h1.38v8.45H12.45a1.37,1.37,0,0,1-1.38-1.37v-5.7A1.38,1.38,0,0,1,12.45,30.29ZM29,49.78a1.38,1.38,0,1,1,1.38-1.38A1.38,1.38,0,0,1,29,49.78Zm12.41-9.66a1.38,1.38,0,1,1-2.76,0V28.91a1.38,1.38,0,1,1,2.76,0Zm5.52-2.75a1.37,1.37,0,0,1-1.38,1.37H44.17V30.29h1.38a1.38,1.38,0,0,1,1.38,1.38Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadsetIcon);
export default __webpack_public_path__ + "static/media/headset_icon.34e9a56b9ae221acbb13ed89a57debc2.svg";
export { ForwardRef as ReactComponent };